import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoRoutingResultsRoutingModule } from './auto-routing-results-routing.module';
import { AutoRoutingResultsComponent } from './auto-routing-results.component';
import { AgGridModule } from 'ag-grid-angular/src/aggrid.module';
import { AutoRoutingDriversComponent } from './components/auto-routing-drivers/auto-routing-drivers.component';
import { AutoRoutingUnassignComponent } from './components/auto-routing-unassign/auto-routing-unassign.component';
import { AutoRoutingByDriverComponent } from './components/auto-routing-by-driver/auto-routing-by-driver.component';
import { DirectivesModule } from '../../directives/directives.module';
import { AutoroutingMapComponent } from './components/autorouting-map/autorouting-map.component';
import { GoogleMapsModule } from '../A2-utils/google-maps/google-maps.module';
import { AutoRoutingService } from '../../services/auto-routing.service';
import { AutoSchedulerService } from '../auto-scheduler/auto-scheduler.service';
import { AssignTripComponent } from './components/assign-trip/assign-trip.component';
import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { FormsModule } from '@angular/forms';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { LiveMapDispatchService } from '../A2-utils/live-map-dispatch/live-map-dispatch.service';

@NgModule({
  imports: [
    CommonModule,
    AutoRoutingResultsRoutingModule,
    DirectivesModule,
    AgGridModule.withComponents([]),
    GoogleMapsModule,
    Trip2ThemeModule,
    FormsModule
  ],
  declarations: [
    AutoRoutingResultsComponent,
    AutoRoutingDriversComponent,
    AutoRoutingUnassignComponent,
    AutoRoutingByDriverComponent,
    AutoroutingMapComponent,
    AssignTripComponent
  ],
  providers: [
    AutoRoutingService,
    AutoSchedulerService,
    T2LoadingService,
    LiveMapDispatchService
  ],
  exports: [
    AutoRoutingResultsComponent,
    AutoRoutingDriversComponent,
    AutoRoutingUnassignComponent,
    AutoRoutingByDriverComponent,
    AutoroutingMapComponent
  ]
})
export class AutoRoutingResultsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/auto-routing-results/auto-routing-results.module.ts